module.exports = __webpack_public_path__ + "img/ic_32_system_android.28a360a4.svg";